import { useEffect } from "react";
import clsx from "clsx";
import { Outlet } from "react-router-dom";
import { AsideDefault } from "./components/aside/AsideDefault";
import { Footer } from "./components/Footer";
import { Toolbar } from "./components/toolbar/Toolbar";
import { ScrollTop } from "./components/ScrollTop";
import { Content } from "./components/Content";
import { PageDataProvider } from "./core";
import { useLocation } from "react-router-dom";
import { MenuComponent } from "../assets/ts/components";
import { GlobalActivityIndicator } from "../../app/modules/shared/globalActivityIndicator/GlobalActivityIndicator";
import { HeaderNotifications } from "./components/header/HeaderNotifications";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "setup/appInsights/ApplicationInsightsService";
import AIAssistantPopup from "app/modules/aiAssistant/popup/AIAssistantPopup";
import { isAssistimoRoute } from "app/modules/aiAssistant/shared/assistimoRoutes";
import { CPLModule } from "app/modules/shared/cplModules/CPLModule";
import { CPLModules } from "cpl-react-common/components/Enums/CPLModules";

const MasterLayout = ({ externalAccess = false }: { externalAccess?: boolean }) => {
  const location = useLocation();
  const isAssistimoPage = isAssistimoRoute(location.pathname);

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, [location.key]);

  return (
    <>
      <GlobalActivityIndicator>
        <PageDataProvider>
          <div className="page d-flex flex-row flex-column-fluid">
            <AsideDefault externalAccess={externalAccess} />
            <div
              className={clsx("wrapper d-flex flex-column flex-row-fluid", {
                "pt-0": location.pathname === "/dashboard",
                "assistimo-layout": isAssistimoPage,
              })}
              id="kt_wrapper"
              style={{ minHeight: "100vh" }}
            >
              <Toolbar externalAccess={externalAccess} />
              <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
                <HeaderNotifications externalAccess={externalAccess} />
                {!isAssistimoPage && (
                  <CPLModule module={CPLModules.AIAssistant}>
                    <AIAssistantPopup />
                  </CPLModule>
                )}
                <div className={"post d-flex flex-column-fluid mt-2"} id="kt_post">
                  <Content>
                    <Outlet />
                  </Content>
                </div>
              </div>
              <Footer />
            </div>
          </div>
          <ScrollTop />
        </PageDataProvider>
      </GlobalActivityIndicator>
    </>
  );
};

export default withAITracking(reactPlugin, MasterLayout);
